import { useCallback, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  Button,
  Paper,
  Rating,
  TextField,
  Typography,
} from '@mui/material';
import { getEmptyNewReview } from '../../interfaces/Review/NewReview';
import { addReview } from '../../api/Review';
import { useThemeColor } from '../../hooks/useThemeColor';

type AddReviewCardProps = {
  productID: number;
  onClose: () => void;
};

export const AddReviewCard = ({ productID, onClose }: AddReviewCardProps) => {
  const { primary, secondary } = useThemeColor();

  const [review, setReview] = useState(getEmptyNewReview(productID));

  const handleSubmit = useCallback(() => {
    addReview(review)
      .then(() => {
        toast.success(
          'Değerlendirmeniz için teşekkür ederiz! Yorumunuz onay aşamasından sonra yayına alınacaktır.',
        );
        setReview(getEmptyNewReview(productID));
        onClose();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [review]);

  return (
    <Paper
      elevation={3}
      sx={{
        py: 1.5,
        px: 1.5,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'start',
        gap: 1,
      }}
    >
      <Typography>Puanınız</Typography>

      <Rating
        value={review.rating}
        onChange={(_, newValue) =>
          setReview({ ...review, rating: newValue ?? 5 })
        }
      />

      <Typography>Yorumunuz</Typography>

      <TextField
        value={review.comment}
        placeholder='Üründen çok memnun kaldım. Tam bir fiyat performans ürünü!'
        onChange={(e) => setReview({ ...review, comment: e.target.value })}
        size='small'
        fullWidth
        multiline
        minRows={3}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.5,
          mt: 1.5,
          width: '100%',
          justifyContent: 'end',
        }}
      >
        <Button
          onClick={handleSubmit}
          variant='contained'
          sx={{
            textTransform: 'none',
            backgroundColor: primary,
            color: secondary,
          }}
        >
          Gönder
        </Button>

        <Button
          onClick={onClose}
          sx={{
            textTransform: 'none',
            color: primary,
          }}
        >
          İptal
        </Button>
      </Box>
    </Paper>
  );
};
